import React, { useEffect, useMemo, useState } from 'react';

import { useDefaultCartContext } from '@/common/contexts/DefaultCartContext';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';
import Cart from '@/ebat/components/blocks/Standalone/Cart/Cart';
import useCart from '@/ebat/hooks/carts/useCart';

const CartContainer = () => {
  const { defaultCart } = useDefaultCartContext();

  const [id, setId] = useState(null);

  const { data: cart, isLoading, isFetching, isSuccess, refetch } = useCart({
    id,
    setDefault: true,
  });

  const isDisabled = useMemo(() => {
    const loading = isLoading || isFetching;

    return {
      disabled: loading,
      loading,
    };
  }, [isFetching, isLoading]);

  // Fix (bad) to show updated cart in iframe
  useEffect(() => {
    const timer = setTimeout(() => {
      if (defaultCart) {
        setId(defaultCart.id);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, [defaultCart]);

  if (isLoading && !cart) {
    return <PageLoader className="standalone-cart" />;
  }

  if (isSuccess) {
    return (
      <main className="standalone-cart">
        <Cart
          cart={cart}
          disabled={isDisabled.disabled}
          isLoading={isDisabled.loading}
          refetchCart={refetch}
        />
      </main>
    );
  }

  return null;
};

export default CartContainer;
